/* eslint-disable @typescript-eslint/camelcase */
import React, { Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch } from 'react-router-dom';
import { connect } from 'store';
import routesPath from 'config/routesPath';
import isEmpty from 'helpers/isEmpty';
import Container from './components/Container';
import Snackbar from 'components/atoms/Snackbar';
import { initConpass } from 'helpers/conpass';
import ChatFullScreenDialog from 'pages/chats/ChatFullScreenDialog';
import FallBackComponent from './components/FallBackComponent';
import UIActionCreators from 'modules/resale/store/reducers/ui/actionCreators';
class DashBoardComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInConsultantScreen: props.isInConsultantScreen,
    };
    this.unlisten = () => ({});
  }

  buildIntercomObject = userType => {
    const {
      dealerStore: { dealer, products, profile },
      userStore: { email, firstName },
      userSite,
    } = this.props;

    return {
      app_id: 'oq8luj4g',
      company_id: dealer?.id,
      company_name: dealer?.name,
      custom_launcher_selector: '#intercom_custom_selector',
      email,
      hide_default_launcher: true,
      name: firstName,
      products: JSON.stringify(products || []),
      profile: profile,
      user_id: userSite?.id,
      userType,
    };
  };

  parseId = () => {
    const {
      userStore: { userSite },
    } = this.props;

    if (this.state.isInConsultantScreen) {
      return undefined;
    }

    if (isEmpty(userSite) || isEmpty((userSite || {}).id)) {
      return undefined;
    }
    return parseInt(((userSite || {}).id || [])[0]);
  };

  async componentDidMount() {
    const {
      dealerStore: {
        getUserType,
        dealer,
        products,
        cityId,
        address,
        number,
        zipCode,
      },
      userStore: { username, email, id: userId, firstName },
    } = this.props;

    if (!dealer) return;
    const { id: dealerId, name, status } = dealer;

    const userInfos = { email, userId, firstName };
    const dealerInfos = {
      dealerId,
      name,
      status,
      cityId,
      address,
      number,
      zipCode,
      products,
    };
    initConpass({ userInfos, dealerInfos });
    if (!this.state.isInConsultantScreen) {
      const userType = await getUserType(username);
      //intercomChat
      const intercomObj = await this.buildIntercomObject(userType);
      window.Intercom('boot', intercomObj);
    }

    this.unlisten = this.props.history.listen((location, action) => {
      //intercomChat
      if (!this.state.isInConsultantScreen) {
        window.Intercom('update');
      }

      const isInsertDealScreen =
        location.pathname === routesPath.getRecursivePath(routesPath.dealForm);

      if (isInsertDealScreen) {
        this.props.inventoryStore.emptyInventoryCurrent();
      } else if (
        location.pathname === routesPath.getRecursivePath(routesPath.myDeals)
      ) {
        this.props.inventoryStore.emptyDeals();
      } else if (
        location.pathname ===
        routesPath.getRecursivePath(routesPath.myResellers)
      ) {
        this.setState({ isInConsultantScreen: true }, () => {
          this.props.dealerStore.setDealerObserved({});
        });
      } else if (
        !(
          location.pathname ===
          routesPath.getRecursivePath(routesPath.myResellers)
        )
      ) {
        this.setState({
          isInConsultantScreen: false,
        });
      } else if (
        !(
          location.pathname ===
          routesPath.getRecursivePath(routesPath.performance)
        )
      ) {
        this.props.performanceStore.emptyDates();
      }
    });
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      dealerStore: { dealer, products, cityId, address, number, zipCode },
      userStore: { email, id: userId, firstName },
    } = this.props;

    if (dealer?.id) {
      return;
    }

    const userInfos = { email, userId, firstName };
    const dealerInfos = {
      dealerId: dealer?.id,
      name: dealer?.name,
      status: dealer?.status,
      cityId,
      address,
      number,
      zipCode,
      products,
    };
    // ** The initConpass Function has a conditional that does`t allow run the code
    // ** every time  the lifeCycle componentDidUpdate is executed
    // ** it`s the reason that  there is not  conditional here
    initConpass({ userInfos, dealerInfos });

    if (!(this.state.isInConsultantScreen === prevState.isInConsultantScreen)) {
      //intercomChat
      const intercomObj = await this.buildIntercomObject();
      window.Intercom('boot', intercomObj);
    }
    if (
      this.props.location.pathname ===
        routesPath.getRecursivePath(routesPath.dealForm) ||
      this.props.location.pathname.startsWith(
        routesPath.getRecursivePath(routesPath.dealForm)
      )
    ) {
      // reset the deal
      this.props.inventoryStore.emptyInventoryCurrent();
    }
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    const { listHeader, isWithoutDealer, routes, ...props } = this.props;

    return (
      <Container
        {...props}
        icons={listHeader}
        isWithoutDealer={isWithoutDealer}
        isConsultantUser={this.props.isConsultantUser}
        isInConsultantScreen={this.state.isInConsultantScreen}
      >
        <Suspense fallback={<FallBackComponent />}>
          <Switch>{routes}</Switch>
        </Suspense>
        <Snackbar />
        <ChatFullScreenDialog />
        <audio id="player" controls style={{ display: 'none' }}>
          <source src="/notification-sound.wav" type="audio/wav" />
        </audio>
      </Container>
    );
  }
}

const DashConnect = connect(DashBoardComponent, [
  'userStore',
  'dealerStore',
  'inventoryStore',
  'performanceStore',
]);

function DashBoardMain(props) {
  const dispatch = useDispatch();
  const userStore = useSelector(state => state.userStore);

  React.useEffect(() => {
    navigator.serviceWorker.addEventListener('message', event => {
      dispatch(
        UIActionCreators.snackbarManagement(
          'PROPOSAL_RECEIVED',
          null,
          true,
          3000,
          {
            title: event.data.notification.title,
            message: event.data.notification.body,
            dealerId: event.data.data.dealerId,
            proposalId: event.data.data.proposalId,
            eventType: event.data.data.eventType,
          }
        )
      );
      document.getElementById('player').play();
    });
  }, []);

  return <DashConnect {...{ ...props, userSite: userStore?.userSite }} />;
}

export default DashBoardMain;
